import { AfterViewInit, Directive, ElementRef, NgZone, OnDestroy } from '@angular/core';
import { TvFeature } from '../data/enum/tv-feature';
import { RemoteButtonKeyCode } from '../data/type/remote-button';
import { ShowcasePageStep } from '../data/type/tv-feature-step';
import { getSteps } from '../utils/feature-step';
import { RemoteControlService } from '../service/remote-control.service';
import { LocalizationService } from '../service/localization.service';
import { Subscription } from 'rxjs';
import { ParameterService } from '../service/parameter.service';

@Directive()
export default abstract class FeaturePage implements OnDestroy, AfterViewInit {
  public featureName: TvFeature;
  protected steps: Array<ShowcasePageStep> = [];
  public stepIndex: number = 0;
  protected remoteControlSubscription: Subscription;
  public currentStep: ShowcasePageStep;
  public isRemoteDisabled: boolean = false;
  protected isAbstract = false;

  abstract containerElementRef: ElementRef;

  constructor(
    protected localizationService: LocalizationService,
    protected remoteControlService: RemoteControlService,
    protected parameterService: ParameterService,
    protected zone: NgZone,
    feature: TvFeature,
  ) {
    this.featureName = feature;
    this.steps = getSteps(feature, this.localizationService);
    this.currentStep = this.steps[this.stepIndex];
    this.remoteControlSubscription = this.remoteControlService.remoteControlEvent.subscribe(
      this.handleRemoteSignal.bind(this),
    );
    // If there is a valid brand name, it's abstract
    this.isAbstract = this.parameterService.isAbstractVersion();
  }

  ngAfterViewInit(): void {
    this.containerElementRef.nativeElement.classList.remove('invisible');
    this.containerElementRef.nativeElement.classList.add('visible');
  }

  ngOnDestroy() {
    this.remoteControlSubscription.unsubscribe();
  }

  protected nextStep() {
    this.zone.run(() => {
      this.stepIndex++;
      this.currentStep = this.steps[this.stepIndex];
      this.isRemoteDisabled = false;
      if (this.stepIndex === this.steps.length - 1) this.handleLastStep();
    });
  }

  abstract handleRemoteSignal(signal: RemoteButtonKeyCode): void;

  abstract handleLastStep(): void;
}
